var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenTickets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 13.2916V8.29163C27.5 6.90413 26.375 5.79163 25 5.79163H5C3.625 5.79163 2.5125 6.90413 2.5125 8.29163V13.2916C3.8875 13.2916 5 14.4166 5 15.7916C5 17.1666 3.8875 18.2916 2.5 18.2916V23.2916C2.5 24.6666 3.625 25.7916 5 25.7916H25C26.375 25.7916 27.5 24.6666 27.5 23.2916V18.2916C26.125 18.2916 25 17.1666 25 15.7916C25 14.4166 26.125 13.2916 27.5 13.2916ZM25 11.4666C23.5125 12.3291 22.5 13.9541 22.5 15.7916C22.5 17.6291 23.5125 19.2541 25 20.1166V23.2916H5V20.1166C6.4875 19.2541 7.5 17.6291 7.5 15.7916C7.5 13.9416 6.5 12.3291 5.0125 11.4666L5 8.29163H25V11.4666ZM13.75 19.5416H16.25V22.0416H13.75V19.5416ZM13.75 14.5416H16.25V17.0416H13.75V14.5416ZM13.75 9.54163H16.25V12.0416H13.75V9.54163Z",
    fill: "#E53E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTickets);
export default __webpack_public_path__ + "static/media/Open Tickets.0b7aa1cb6892f09ac768057bd4335e39.svg";
export { ForwardRef as ReactComponent };